import { Footer } from '@everlywell/leaves';
import React, { Ref } from 'react';
import { handleIterableSubscription } from 'utils/iterableSubscribe';

const FooterContainer = React.forwardRef((props, ref: Ref<HTMLDivElement>) => {
  const handleSubscribeSubmit = ({
    subscribeEmail,
  }: {
    [key: string]: string;
  }) => {
    handleIterableSubscription(subscribeEmail);
  };

  return (
    <div ref={ref}>
      <Footer onSubscribeSubmit={handleSubscribeSubmit} />
    </div>
  );
});

export default FooterContainer;
